/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useContext } from "react";
import AppCoffeeMugContextInstance from "./AppCoffeeMugContextInstance";
import IAppCoffeeMugContext from "./IAppCoffeeMugContext";

export interface AppCoffeeMugContextProps {
    children: React.ReactNode;
}

const appCoffeeMugContext = React.createContext({} as AppCoffeeMugContextInstance);

export default function AppCoffeeMugContext(props: AppCoffeeMugContextProps) {
    const appCoffeeMugContextInstance = new AppCoffeeMugContextInstance();
    return (
        <appCoffeeMugContext.Provider value={appCoffeeMugContextInstance}>
            {props.children}
        </appCoffeeMugContext.Provider>
    );
}

export function useAppCoffeeMugContext(): IAppCoffeeMugContext {
    return useContext(appCoffeeMugContext);
}
